import React from 'react';
import PropTypes from 'prop-types';

export default class ScrollToMe extends React.Component {
  static propTypes = {
    offsetTop: PropTypes.number,
  };

  componentDidMount() {
    this.scrollToElem();
  }

  scrollToElem = () => {
    if (this.scrollDiv) {
      const { top } = this.scrollDiv.getBoundingClientRect();
      if (top < 0) {
        const newScroll = document.body.scrollTop - top + this.props.offsetTop;
        window.scrollTo(window.scrollLeft, newScroll);
      }
    }
  };

  render() {
    return <div style={{ height: 0 }} ref={elem => (this.scrollDiv = elem)} />;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ScrollToMe/index.js